import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import LabelAndSelectChange from '../form/labelAndSelectChange';

import { getGrupoFisicoList } from './selectdbAtions';

class SelectAllGrupoFisico extends Component {
  componentWillMount() {
    this.props.getGrupoFisicoList();
  }

  renderOptions() {
    const list = this.props.list || [];

    if (list.length === 0) {
      return <option value="">Carregando...</option>;
    }

    return list.map(grupo => (
      <option key={grupo.id} value={grupo.id}>
        {grupo.id} - {grupo.descricao}
      </option>
    ));
  }

  render() {
    return (
      <LabelAndSelectChange
        id={this.props.id}
        name={this.props.name}
        label={this.props.label}
        cols={this.props.cols}
        hideLabel={this.props.hideLabel !== undefined ? this.props.hideLabel : true}
        onChange={this.props.onChange}
        value={this.props.value}
        disabled={this.props.disabled}
        selectStyle={this.props.selectStyle}
      >
        <option value="">Selecione</option>
        {this.renderOptions()}
      </LabelAndSelectChange>
    );
  }
}

const mapStateToProps = state => ({ list: state.grupoFisicoCad.list });
const mapDispatchToProps = dispatch => bindActionCreators({ getGrupoFisicoList }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectAllGrupoFisico);
